import { FC, HTMLAttributes } from 'react';

export const ReactComponent: FC<HTMLAttributes<SVGElement>> = (props) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M12 17H3C1.89543 17 1 16.1046 1 15V5C1 3.89543 1.89543 3 3 3H12V17ZM17 3C18.1046 3 19 3.89543 19 5V15C19 16.1046 18.1046 17 17 17H13V3H17ZM14.5 11C14.2239 11 14 11.2239 14 11.5C14 11.7761 14.2239 12 14.5 12H17.5C17.7761 12 18 11.7761 18 11.5C18 11.2239 17.7761 11 17.5 11H14.5ZM14.5 8.5C14.2239 8.5 14 8.72386 14 9C14 9.27614 14.2239 9.5 14.5 9.5H17.5C17.7761 9.5 18 9.27614 18 9C18 8.72386 17.7761 8.5 17.5 8.5H14.5ZM14.5 6C14.2239 6 14 6.22386 14 6.5C14 6.77614 14.2239 7 14.5 7H17.5C17.7761 7 18 6.77614 18 6.5C18 6.22386 17.7761 6 17.5 6H14.5Z"
      fill="#B3BBCB"
    />
  </svg>
);
